import { TIPO_VOTO } from '@/dominio/TipoVoto';
import ChairAltIcon from '@mui/icons-material/ChairAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Badge, Tooltip, Typography } from '@mui/material';
import { green, grey, red } from '@mui/material/colors';
import PropTypes from 'prop-types';
import { Component } from 'react';

class IconeCadeiraJaVotou extends Component {
    render() {
        let corCadeira;
        let corCheck;

        if (this.props.tonsDeCinza) {
            corCadeira = grey[700];
            corCheck = grey[800];
        } else {
            corCadeira = red[800];
            corCheck = green[700];
        }

        return (
            <Tooltip
                title={<Typography>{TIPO_VOTO.CADEIRA_JA_VOTOU.descricao}</Typography>}
                arrow
            >
                <span>
                    {' '}
                    {/* Span necessário para o Tooltip funcionar em elementos com pointer-events específicos */}
                    <Badge
                        overlap="circular"
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        badgeContent={
                            <CheckCircleIcon
                                sx={{
                                    fontSize: '14px',
                                    color: corCheck,
                                    backgroundColor: 'white',
                                    borderRadius: '50%'
                                }}
                            />
                        }
                    >
                        <ChairAltIcon
                            sx={{
                                fontSize: '28px',
                                color: corCadeira
                            }}
                        />
                    </Badge>
                </span>
            </Tooltip>
        );
    }
}

IconeCadeiraJaVotou.propTypes = {
    tonsDeCinza: PropTypes.bool
};

export default IconeCadeiraJaVotou;
